export const APP_TITLE = "Little Tags";
export const USER_SET_NAME_MESSAGE =
  "Logged In Successfully, Please update your name";
// App Loader
export const APP_LOADER_TEXT = "Getting Things Ready...";

// Cart Item
export const CART_ITEM_REMOVE_BUTTON_TEXT = "Remove";

// Confirmation Popup
export const CONFIRMATION_POPUP_SUCCESS_BUTTON_TEXT = "Proceed";
export const CONFIRMATION_POPUP_CANCEL_BUTTON_TEXT = "Cancel";

// Dropdown
export const DROPDOWN_ICON_PLACEHOLDER = "Dropdown Icon";

// Header
export const LOGIN_SIGNUP_CONTROL_TEXT = "Login / Signup";

// Hero
export const HERO_HEADING = "Online Flee Market for Clothes";
export const HERO_SUBHEADING = "Its time to recycle";

// Item Quantity
export const ITEM_QUANTITY_LEFT_BUTTON_PLACEHOLDER = "Decrease Item Count";
export const ITEM_QUANTITY_RIGHT_BUTTON_PLACEHOLDER = "Increase Item Count";

// Login
export const LOGIN_TITLE = "Log In / Sign Up";
export const LOGIN_SUBTITLE = "Log In / Sign Up Using Your";
export const LOGIN_WITH_GOOGLE_PLACEHOLDER = "Google Sign In";
export const LOGIN_WITH_FACEBOOK_PLACEHOLDER = "Facebook Sign In";
export const LOGIN_WITH_GOOGLE_TEXT = "Google Account";
export const LOGIN_WITH_FACEBOOK_TEXT = "Facebook Account";
export const LOGIN_WITH_PHONE_TEXT = "Phone Number";

// Menu
export const MENU_CATEGORIES_TITLE = "CATEGORIES";
export const MENU_GREETING_TEXT = "Hey,";

// Order Item
export const ORDER_ITEM_ORDER_AGAIN_TEXT = "ORDER AGAIN";

// Payment Status
export const PAYMENT_STATUS_SUCCESS_ICON_PLACEHOLDER = "Success Icon";
export const PAYMENT_STATUS_FAILURE_ICON_PLACEHOLDER = "Failure Icon";
export const PAYMENT_STATUS_SUCCESS_MESSAGE = "Thank you for shopping with us";
export const PAYMENT_STATUS_FAILURE_MESSAGE = "Ohh Sorry Your Payment Failed";
export const PAYMENT_STATUS_SUCCESS_ACTION_TEXT = "Continue Shopping";
export const PAYMENT_STATUS_FAILURE_ACTION_TEXT = "Retry Payment";

// Search
export const SEARCH_PLACEHOLDER = "Search...";
export const SEARCH_NO_RESULTS_TEXT = "No Results Found";

// Phone Auth Popup
export const PHONE_AUTH_OTP_SENT_MESSAGE = "OTP Sent to your phone number";
export const PHONE_AUTH_ENTER_OTP_LABEL = "Enter OTP";
export const PHONE_AUTH_ENTER_PHONE_LABEL = "Enter Phone Number";
export const PHONE_AUTH_OTP_LENGTH = 6;
export const PHONE_AUTH_PHONE_NUMBER_LENGTH = 10;
export const PHONE_AUTH_BUTTON_TEXT_LOADING = "Loading..";
export const PHONE_AUTH_BUTTON_TEXT_VERIFY_OTP = "Verify OTP";
export const PHONE_AUTH_BUTTON_TEXT_REQUEST_OTP = "Request OTP";

// Select User Name Popup
export const SELECT_USER_NAME_ACTION_BUTTON_TEXT = "Save";
export const SELECT_USER_NAME_INPUT_LABEL = "Enter Your Name";
export const SELECT_USER_NAME_SUCCESS_MESSAGE = "User's name set successfuly";

// Add Address Screen
export const ADD_ADDRESS = {
  FIRST_NAME_VALIDATION_MESSAGE: "First name is required",
  LAST_NAME_VALIDATION_MESSAGE: "Last name is required",
  EMAIL_REQUIRED_MESSAGE: "Email is required",
  EMAIL_VALIDATION_MESSAGE: "Email is not valid",
  MOBILE_VALIDATION_MESSAGE: "Mobile is required",
  ADDRESS_LINE_1_VALIDATION_MESSAGE: "Address Line 1 is required",
  ADDRESS_LINE_2_VALIDATION_MESSAGE: "Address Line 2 is required",
  PINCODE_VALIDATION_MESSAGE: "Pincode is required",
  REQUIRED_VALIDATION_MESSAGE: "Required",
  ADDRESS_ADDED_MESSAGE: "Address Added Successfuly",
  SCREEN_TITLE: "Delivering To",
  FIRST_NAME_LABEL: "First Name",
  LAST_NAME_LABEL: "Last Name",
  EMAIL_LABEL: "Email",
  MOBILE_LABEL: "Mobile Number",
  ADDRESS_LINE_1_LABEL: "Address Line 1",
  ADDRESS_LINE_2_LABEL: "Address Line 2",
  STATE_LABEL: "State",
  PINCODE_LABEL: "Pin Code",
  ACTION_BUTTON_TEXT: "Add Information",
};

// Cart Screen
export const CART = {
  SCREEN_TITLE: "Your Cart",
  EMPTY_CART_MESSAGE: "No Items Added to Cart Yet",
  CHECKOUT_TITLE: "Checkout",
};

// Home Screen
export const HOME = {
  CATEGORIES_TTTLE: "Most In Demand",
};

// ORDERS Screen
export const ORDERS = {
  SCREEN_TITLE: "Your Orders",
};

// Payment Details
export const PRODUCT_DETAILS = {
  QUANTITY_LABEL: "Quantity",
  ADDED_TO_CART_MESSAGE: " Added to cart",
  ADD_TO_CART_TEXT: "ADD TO CART",
  REMOVE_FROM_CART_TEXT: "REMOVE FROM CART",
  SIZE_LABEL:'Size'
};

// Product List Screen
export const PRODUCT_LIST = {
  SCREEN_TITLE: "All Products",
};

// Select Address Screen
export const SELECT_ADDRESS = {
  SCREEN_TITLE: "Delivering To",
  ADD_ADDRESS_BUTTON_TEXT: "ADD NEW ADDRESS",
  SUCCESS_BUTTON_TEXT: "PROCEED",
};

// Select Payment Method Screen
export const SELECT_PAYMENT_METHOD = {
  SCREEN_TITLE: "Delivering To",
  PAYMENT_METHOD_TITLE: "Method of Payment",
  SUCCESS_BUTTON_TEXT: "PROCEED TO PAYMENT",
  ADDRESS_VALIDATION_MESSAGE: "Please add atleast one address to proceed",
  PRODUCT_VALIDATION_MESSAGE: "Please add atleast one product to cart",
};

// Toast Messages
export const LOGGED_IN_MESSAGE = (name: string) => `Logged in as ${name}`;
export const LOGGED_OUT_MESSAGE = "Logged Out Successfully";
export const LOGOUT_CONFIRMATION_MESSAGE = "Are you sure you want to Logout";

export const CLOTH_SIZES = [
  {
    value:'xs',
    label:'XS'
  },
  {
    value:'s',
    label:'S'
  },
  {
    value:'m',
    label:'M'
  },
  {
    value:'l',
    label:'L'
  }, {
    value:'xl',
    label:'XL'
  }
]